import { createContext, type Context } from 'react';
import type { User } from 'firebase/auth';

export type AuthStatusT = 'loading' | 'authenticated' | 'unauthenticated';

export type AuthContextValueT<TUser = User> = Readonly<{
  user: TUser | null;
  status: AuthStatusT;
  isAuthenticated: boolean;
  isLoading: boolean;
  logout: () => Promise<void>;
}>;

export type AuthContextT<TUser = User> = Context<AuthContextValueT<TUser> | null>;

export function createAuthContext<TUser = User>(): AuthContextT<TUser> {
  return createContext<AuthContextValueT<TUser> | null>(null);
}

export const AuthContext = createAuthContext<User>();
